import LWCardWrapped, { LWCard, types, headerAlignment } from './LWCard';

export { LWCard, types, headerAlignment };

export default LWCardWrapped;
